import { render, staticRenderFns } from "./Consignacao.vue?vue&type=template&id=d45f68a6&scoped=true&"
import script from "./Consignacao.vue?vue&type=script&lang=js&"
export * from "./Consignacao.vue?vue&type=script&lang=js&"
import style0 from "./Consignacao.vue?vue&type=style&index=0&id=d45f68a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45f68a6",
  null
  
)

export default component.exports